import firebase from 'firebase';
import { Moment } from 'moment-recur-ts';
import { useEffect, useState } from 'react';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import {
  FirebaseConfig,
  FirebaseCourseWithUid,
  FirebaseCourseWithUidAndImg,
} from '../types/types';
import { getCourseOfTheDate } from '../utils/getCourseOfTheDate';
import { getCoursesOfTheDay } from '../utils/getCoursesOfTheDay';
import { useConfig } from './useConfig';

export const useCourses = (noImages?: boolean) => {
  const [result, setResult] = useState<FirebaseCourseWithUidAndImg[] | null>(
    null
  );

  const [coursesData, loading, error] =
    useCollectionData<FirebaseCourseWithUid>(
      firebase.firestore().collection('courses'),
      { idField: 'uid' }
    );

  const config = useConfig();

  useEffect(() => {
    const fetchData = async (
      courses: FirebaseCourseWithUid[],
      conf: FirebaseConfig
    ) => {
      const res = await Promise.all(
        courses.map(async (course) => {
          let url = '';
          if (!noImages) {
            try {
              url = await firebase
                .storage()
                .ref(
                  course.images.coverThumb ||
                    course.images.cover ||
                    conf.fallbackImages.coverThumb ||
                    conf.fallbackImages.cover
                )
                .getDownloadURL()
                .then((v: string) => v);
            } catch (e) {
              console.error(e);
            }
          }
          return { ...course, img: url };
        })
      );
      setResult(res);
    };
    coursesData && config && fetchData(coursesData, config);
  }, [coursesData, config]);

  return {
    courses: result,
    config,
    error,
    loading,
  };
};

export const useCourseOfTheDate = (date: Moment, categoryId: string) => {
  const res = useCourses();

  return { ...res, courses: getCourseOfTheDate(date, res.courses, categoryId) };
};

export const useCoursesOfTheDay = (
  categoryId: string,
  startOnMonday?: boolean,
  noImages?: boolean
) => {
  const res = useCourses(noImages);

  return {
    ...res,
    courses: getCoursesOfTheDay(7, res.courses, categoryId, startOnMonday),
  };
};
